module.exports = __webpack_public_path__ + "img/1551522371.672aee46.jpg";